import { defineMessages } from 'react-intl';

export default defineMessages({
    weWillReviewYourPaymentDetailsNext: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.We\'ll review your payment details next',
        defaultMessage: 'We\'ll review {reviewYourPaymentDetails} next'
    },
    reviewYourPaymentDetails: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.your payment details',
        defaultMessage: 'your payment details'
    },
    emailAddress: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.Email Address',
        defaultMessage: 'Email Address'
    },
    enterEmailAddress: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.Enter email address',
        defaultMessage: 'Enter email address'
    },
    emailScript: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.EMAIL SCRIPT',
        defaultMessage: 'EMAIL SCRIPT'
    },
    emailScriptContent: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.emailScriptContent',
        defaultMessage: 'When you provide your email address, you consent to receiving emails about your online quote and other product information from third parties working for us who we gave your email address.  We do not share our customer’s personal information with unaffiliated third parties for their own direct marketing purposes.  To view our complete Privacy Policy, click on the Privacy Policy link on the bottom of the screen.'
    },
    invalidEmail:{
        id:'ml.quoteandbind.ho.additionalinfoprebind.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    showAnimalExclusionWarningMessage: {
        id: 'ml.agent.quoteandbind.ho.additionalInfoPrebind.We will require an Animal Liability Exclusion to be included on your policy. Additional details will be included on your quote.',
        defaultMessage: 'We will require an Animal Liability Exclusion to be included on your policy. Please provide the additional details below:',
    },
    animalsHeader: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.Animals',
        defaultMessage: 'Animals'
    },
    homeInspectionHeader: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.homeInspectionHeader',
        defaultMessage: 'Home Inspection'
    },
    homeInspectionAn: {
        id: 'ml.quoteandbind.ho.inspection.type.homeInspectionAn',
        defaultMessage: 'An '
    },
    homeInspectionrequiredP: {
        id: 'ml.quoteandbind.ho.inspection.type.homeInspectionrequiredP',
        defaultMessage: ' inspection will be required for this policy.'
    },
    homeSelfSurveyError: {
        id: 'ml.quoteandbind.ho.inspection.An email address or cell number is required for a self-survey inspection',
        defaultMessage: 'An email address or cell number is required for a self-survey inspection. The cell number can be added by entering it on the Customer Details screen and then clicking Return to Quote.'
    },
    selectAnimalHeader: {
        id: "ml.quoteandbind.ho.additionalinfoprebind.Select Animal",
        defaultMessage: "Select the type of domestic animal"
    },
    requiredField: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.requiredField',
        defaultMessage: 'Mobile number is required when esignature options is selected as "Text"'
    },
    requiredFieldForEsignOptions: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.requiredFieldForEsignOptions',
        defaultMessage: 'Missing required field "eSignature Options"'
    },
    requiredFieldForEsign: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.requiredFieldForEsign',
        defaultMessage: ' Missing required field "eSign"'
    },
    personalLiablityError: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.Reduce Personal Liability coverage limits.',
        defaultMessage: 'Reduce Personal Liability coverage limits. Personal Liability coverage limit of $1 million or higher is not allowed on the policy when Additional Insured or Additional Interest has contact type as company.'
    },
    requiredFieldEmail: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.requiredFieldEmail.',
        defaultMessage: 'Email is required when esignature options is selected as "Email"'
    },
    requiredFieldEsignAck: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.requiredFieldEsignAck.',
        defaultMessage: 'Text Acknowledgement is required when esignature options is selected as "Text"'
    }
});
